import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';

import {
  MobileHeaderBackButton,
  MobileHeaderBar,
  MobileHeaderForwardButton,
  MobileHeaderContent,
  MobileHeaderTitleArea,
  MobileHeaderTrailing,
} from './MobileHeader.style';
import { MobileHeaderTitle } from './MobileHeaderTitle';

export type MobileHeaderProps = {
  title?: ReactNode;
  onBack?: () => void;
  onForward?: () => void;
  children?: ReactNode;
};

export default function MobileHeader({ title, onBack, onForward, children }: MobileHeaderProps) {
  const { t } = useTranslation();
  const titleElement =
    typeof title === 'string' || typeof title === 'number' ? <MobileHeaderTitle>{title}</MobileHeaderTitle> : title;

  return (
    <>
      <MobileHeaderBar>
        {onBack && (
          <MobileHeaderBackButton aria-label={t('mobileHeader.back')} data-qa-element-id="back_button" onClick={onBack}>
            <ArrowBack />
          </MobileHeaderBackButton>
        )}
        <MobileHeaderTitleArea>{titleElement}</MobileHeaderTitleArea>
        {onForward && (
          <MobileHeaderTrailing>
            <MobileHeaderForwardButton
              aria-label={t('mobileHeader.forward')}
              data-qa-element-id="forward_button"
              onClick={onForward}
            >
              <ArrowForward />
            </MobileHeaderForwardButton>
          </MobileHeaderTrailing>
        )}
      </MobileHeaderBar>
      {children && <MobileHeaderContent>{children}</MobileHeaderContent>}
    </>
  );
}
